// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"PageLayout__wrapper__OzLjG","content":"PageLayout__content__1kNGX","collapsed":"PageLayout__collapsed__3Kac2","full":"PageLayout__full__1OZqH","sidebar":"PageLayout__sidebar__2P9NB","headline":"PageLayout__headline__2Qnln","toggleButton":"PageLayout__toggleButton__14Vlk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PageLayout/PageLayout.css
// module id = 3173
// module chunks = 0